(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('VentadetalleDetailController', VentadetalleDetailController);

    VentadetalleDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Ventadetalle'];

    function VentadetalleDetailController($scope, $rootScope, $stateParams, previousState, entity, Ventadetalle) {
        var vm = this;

        vm.ventadetalle = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:ventadetalleUpdate', function(event, result) {
            vm.ventadetalle = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
